// TODO: Thing seems pretty generic, it should probably be moved elsewhere
import {AssetType} from "../../redux/assets-slice";

export const isModelFile = (asset) => {
  return (asset.type === AssetType.IFC)
    || (asset.type === AssetType.DXF)
    || (asset.type === AssetType.SHP);
};

export const isStreamablePointsFile = (asset) => {
  return (asset.type === AssetType.Encompass)
    || (asset.type === AssetType.Potree);
};

export const isRawPointsFile = (asset) => {
  return (asset.type === AssetType.LAS)
    || (asset.type === AssetType.E57Points);
};